import React from 'react';
import { cn } from '../../lib/utils';
import { STICKY_NOTE_COLORS } from '../../utils/workflowBuilderUtils';

const WorkflowStickyNotesPanel = ({
  onSelectColor,
  onHideNotes,
  notesVisible,
}) => (
  <div
    className="absolute left-14 top-3 z-30 w-36 rounded-xl border border-slate-200 bg-white p-3 shadow-xl"
    data-testid="sticky-notes-palette"
  >
    <div className="grid grid-cols-2 gap-2">
      {STICKY_NOTE_COLORS.map((color) => (
        <button
          key={color.id}
          type="button"
          onClick={() => onSelectColor(color.id)}
          className={cn('h-8 w-full rounded-md border', color.className)}
          aria-label={`Add ${color.id} sticky note`}
          data-testid={`sticky-color-${color.id}`}
        />
      ))}
    </div>
    <button
      type="button"
      onClick={onHideNotes}
      className="mt-3 w-full rounded-md border border-slate-200 px-2 py-1.5 text-xs font-medium text-slate-600 hover:bg-slate-50"
    >
      {notesVisible ? 'Hide notes' : 'Show notes'}
    </button>
  </div>
);

export default WorkflowStickyNotesPanel;
